import i18n from '@opsbase/lib-i18n';
import Palette from '@opsbase/lib-palette';
import useCss from '@opsbase/web-css';
import Card from '@opsbase/web-layout/Card';
import Dots from '@opsbase/web-ui/Dots';
import Text from '@opsbase/web-ui/Text';
import React from 'react';
import { makeSectionClasses } from '../OpDefinitionEditOverviewTab';
export function OpCountOverviewSection(props) {
    const { opCount, opCountLoading, className } = props;
    const myCss = useCss(makeSectionClasses);
    return (React.createElement(Card, { classes: { root: className } },
        React.createElement(Text, { variant: "h3" }, i18n.t('no-of-times-performed')),
        opCountLoading && (React.createElement(Dots, { style: { margin: '32px auto' }, color: Palette.LavendarGrey })),
        !opCountLoading && React.createElement(Text, { className: myCss.massiveText }, opCount)));
}
export default OpCountOverviewSection;
